import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentFilterCheckboxesComponent } from './instrument-filter-checkboxes.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    InstrumentFilterCheckboxesComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    InstrumentFilterCheckboxesComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class InstrumentFilterCheckboxesModule { }
